var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.analytics)?_c('div',{staticClass:"visit--container"},_vm._l((_vm.analytics),function(data,index){return _c('div',{key:`analytics-${index}`,staticClass:"visit"},[_c('span',{staticClass:"visit--name"},[_vm._v(_vm._s(`${_vm.$t('listing.' + data.analytic_type)}: `))]),_c('span',[_vm._v(_vm._s(`${data.amount ? data.amount : 0}`))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }